<div class="med-group-control">
  <ng-content></ng-content>

  <button
    *ngIf="hasSwitchBtn && countOfHidden > 0"
    type="button"
    class="med-group-control__hide-btn"
    (click)="onToggle()"
  >
    <ng-container *ngIf="!showAll; else hideIcon"> +{{ countOfHidden }} </ng-container>

    <ng-template #hideIcon>
      <med-icon-triangle-up size="16"></med-icon-triangle-up>
    </ng-template>
  </button>
</div>
